import { Heading, Text, Button, CharacterCard } from '@bq/web-components';
import styles from './ProblemSection.module.css';

export interface ProblemSectionProps {
  onSignUp?: () => void;
}

const characters = [
  {
    imageSrc: '/assets/images/bill-lumbergh.png',
    imageAlt: 'A picture of Bill Lumbergh',
    title: 'Seriously, another meeting?',
    category: 'ADMINISTRATION.',
    body: "Management craves updates \u2014 slides, a TPS report, or yet another \u2018efficiency\u2019 meeting with the two Bobs. Project overheads are inevitable and the time required sucks the life out of any dev. But hey, if you could just go ahead and fill out your timesheet, that\u2019d be great. Riggggght... Yeaaah.",
    quote: 'Go ahead and come in on Saturday.',
    attribution: 'Bill Lumbergh',
  },
  {
    imageSrc: '/assets/images/lloyd-christmas.png',
    imageAlt: 'A picture of Lloyd Christmas',
    title: 'Dumb & Dumberer',
    category: 'TEAMWORK.',
    body: "Standups, retros, sprint planning, grooming \u2014 and a Slack thread with 37 unread messages. Meanwhile, old Bill over there has scheduled yet another sync. Your PR? Still waiting on approval. There\u2019s more talking, less building.",
    quote: 'So your saying there is a chance.',
    attribution: 'Lloyd Christmas',
  },
  {
    imageSrc: '/assets/images/the-dude.png',
    imageAlt: 'A picture of The Dude',
    title: 'Return to office anyone?',
    category: 'INSPIRATION!',
    body: "So, you envisioned days of crafting epic tech maybe even flying on a magic 'rug' and dominating the universe, or at least making a dent in it. You thought it will be a great team and fun culture. Return to Office anyone?",
    quote: 'This aggression will not stand, man.',
    attribution: 'The Dude',
  },
];

export function ProblemSection({ onSignUp }: ProblemSectionProps) {
  return (
    <section data-crd-id="r4.bq-problem-section" data-crd-layer="r4" className={styles.section} id="problem">
      <div className={styles.container}>
        <div className={styles.header}>
          <Text size="r2" align="center" color="n700" className={styles.eyebrow}>
            Mere Mortals
          </Text>
          <Heading level={2} align="center">
            The Obstacles We Face
          </Heading>
        </div>

        <div className={styles.grid}>
          {characters.map((char) => (
            <CharacterCard key={char.attribution} {...char} />
          ))}
        </div>

        <div className={styles.closer}>
          <Heading level={2} align="center">
            There&apos;s a Better Way Grasshopper...
          </Heading>

          <div className={styles.ctas}>
            <Button variant="primary" size="large" onClick={onSignUp}>
              Sign Up
            </Button>
            <Button variant="link" href="#solution">
              Learn More
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
